import { render, staticRenderFns } from "./download-wx.vue?vue&type=template&id=34c34bf6&scoped=true&"
import script from "./download-wx.vue?vue&type=script&lang=ts&"
export * from "./download-wx.vue?vue&type=script&lang=ts&"
import style0 from "./download-wx.vue?vue&type=style&index=0&id=34c34bf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c34bf6",
  null
  
)

export default component.exports